export const validationRules = {
    firstName: {
        required: true,
        maxLength: 35,
        noWhiteSpace: true
    },
    lastName: {
        required: true,
        maxLength: 35,
        noWhiteSpace: true
    },
    dob: {
        required: true,
        format: /^\d{2}\/\d{2}\/\d{4}$/,
        notInTheFuture: true,
        validDateFormat: true
    },
    specialty: {
        required: true
    },
    clinicName: {
        required: true,
        maxLength: 70,
        noWhiteSpace: true
    },
    homeAddressLine1: {
        required: true,
        maxLength: 40,
        noWhiteSpace: true
    },
    homeCity: {
        required: true,
        maxLength: 35,
        noWhiteSpace: true
    },
    homeState: {
        required: true
    },
    homeZipCode: {
        required: true,
        format: /^[0-9]{5}([0-9]{4})?$/
    },
    homePhone: {
        required: true,
        format: /^\([0-9]{3}\) [0-9]{3}-[0-9]{4}$/
    },
    ssn: {
        required: true,
        format: /^(?:\d{3}-\d{2}|\*{3}-\*{2})-\d{4}$/
    },
    email: {
        required: true,
        maxLength: 80,
        format: /^([a-zA-Z0-9_\-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/
    },
    stateLicense: {
        required: true
    },
    issuingState: {
        required: true
    },
    expDate: {
        required: true,
        format: /^\d{2}\/\d{2}\/\d{4}$/,
        notInThePast: true,
        validDateFormat: true
    },
    dea: {
        required: true,
        format: /^^\S{2}\d{7}$/
    },
    deaExpDate: {
        required: true,
        format: /^\d{2}\/\d{2}\/\d{4}$/,
        notInThePast: true,
        validDateFormat: true
    },
    degree: {
        required: true,
        maxLength: 35,
        noWhiteSpace: true
    },
    npi: {
        required: true,
        format: /^[0-9]{10}$/
    },
    // taxId: {
    //     required: true,
    //     format: /^[0-9]{9}$/
    // }
};

// export const validationRulesClinic = {
//     addressLine1: {
//         required: true,
//         maxLength: 40,
//         noWhiteSpace: true
//     },
//     city: {
//         required: true,
//         maxLength: 35,
//         noWhiteSpace: true
//     },
//     state: {
//         required: true
//     },
//     zipCode: {
//         required: true,
//         format: /^[0-9]{5}([0-9]{4})?$/
//     },
//     phone: {
//         required: true,
//         format: /^\([0-9]{3}\) [0-9]{3}-[0-9]{4}$/
//     },
//     fax: {
//         required: true,
//         format: /^\([0-9]{3}\) [0-9]{3}-[0-9]{4}$/
//     }
// };


// WEBPACK FOOTER //
// ./src/components/Provider/validationRules.ts